import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBazdidIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 79,
	height: 70,
	viewBox: "0 0 79 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 35.1896,
			cy: 32.4209,
			rx: 29.4865,
			ry: 29.7725,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.223 32.0518C58.223 48.0873 45.3504 61.0742 29.4865 61.0742C13.6226 61.0742 0.75 48.0873 0.75 32.0518C0.75 16.0163 13.6226 3.0293 29.4865 3.0293C45.3504 3.0293 58.223 16.0163 58.223 32.0518Z",
			stroke: "#7548F0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 61.0145,
			cy: 17.109,
			rx: 2.49886,
			ry: 2.52309,
			fill: "#F6F5FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			opacity: .33,
			cx: 56.5538,
			cy: 2.01847,
			rx: 1.99908,
			ry: 2.01847,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40.6314,
			cy: 66.973,
			rx: 2.99863,
			ry: 3.02771,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.8665,
			cy: 67.7365,
			rx: 1.49931,
			ry: 1.51385,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			opacity: .3,
			cx: 76.9991,
			cy: 16.6044,
			rx: 1.99908,
			ry: 2.01847,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3359 15.334V20.334",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.6641 15.334V20.334",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 26.1673V40.334C44 45.334 41.5 48.6673 35.6667 48.6673H22.3333C16.5 48.6673 14 45.334 14 40.334V26.1673C14 21.1673 16.5 17.834 22.3333 17.834H35.6667C41.5 17.834 44 21.1673 44 26.1673Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.1601 34.8333H35.1751",
			stroke: "#0DC277",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.1601 39.8333H35.1751",
			stroke: "#0DC277",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.9961 34.8333H29.011",
			stroke: "#0DC277",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 39.832H29.015",
			stroke: "#0DC277",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8242 34.8333H22.8391",
			stroke: "#0DC277",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8242 39.8333H22.8391",
			stroke: "#0DC277",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8359 27.1504H43.1693",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.0078 49C56.0078 54.52 51.5278 59 46.0078 59C40.4878 59 36.0078 54.52 36.0078 49C36.0078 43.48 40.4878 39 46.0078 39C51.5278 39 56.0078 43.48 56.0078 49Z",
			fill: "#F0EEFF",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.7206 52.1798L46.6206 50.3298C46.0806 50.0098 45.6406 49.2398 45.6406 48.6098V44.5098",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBazdidIcon;
